<template>
    <div class="tab-panel padded">
        <extra-form @toggleIsDisabled="toggleIsDisabled" @readyToSave="readyToSave"></extra-form>

        <div class="d-flex justify-content-end">
            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
            <button type="button" class="btn ok wider" @click="save" :disabled="isDisabled">Save</button>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ExtraForm from './ExtraForm'

    export default {
        data: function() {
            return {
                isDisabled: true,
                updatedForm: null,
            }
        },
        created: function() {
            this.updatedForm = this.getSelectedExtra ? JSON.parse(JSON.stringify(this.getSelectedExtra)) : {};
        },
        computed: {
            ...mapGetters([
                'getSelectedExtra',
                'account',
            ])
        },
        methods: {
            ...mapActions([
                'closeModal',
                'updateItem',
                'clearSelectedExtra'
            ]),
            toggleIsDisabled: function(isDisabled) {
                this.isDisabled = isDisabled;
            },
            applyTaxToAllPrices: function(){
                console.log('this.updatedForm');
                console.log(this.updatedForm);
                this.updatedForm.prices.map((price, index) => {
                    if(index > 0){ //prevents changing it self
                        price.vatType = this.updatedForm.prices[0].vatType
                        price.priceIncludeTaxes = this.updatedForm.prices[0].priceIncludeTaxes
                    }
                })
            },
            cancel: function() {
                this.clearSelectedExtra();
                this.closeModal();
            },
            readyToSave: function(updatedForm) {
                this.updatedForm = updatedForm;
                this.applyTaxToAllPrices()
            },
            save: function() {
                this.applyTaxToAllPrices()
                this.updateItem({
                    object: 'extra',
                    action: this.getSelectedExtra ? 'edit' : 'create',
                    table: 'extras',
                    fields: { supplierId: this.account.supplierId, extra: this.updatedForm }
                });
            },
        },
        components: {
            ExtraForm,
        }
    }
</script>



// WEBPACK FOOTER //
// ExtraEdit.vue?72d26070